function loadAndCall(el) {
    import('../simplepopup.js').then(({default: simplePopUpFromElement}) => simplePopUpFromElement(el));
}

function handleClick(e) {
    var el = e.target,
        found = false;

    while (el && el !== document && !found) {
        if (el.dataset.modal || el.dataset.popup) {
            found = true;

            e.preventDefault();

            loadAndCall(el);
        } else {
            el = el.parentNode;
        }
    }
}

export default function listenForElementWithModalAttributes() {
    document.addEventListener('click', handleClick, true);
}
